<template>
  <v-form v-model="valid" @submit.prevent="submit" ref="form">    
    <v-row>
      <v-col
        xs="12"
        md="8"
      >
        <v-text-field
          v-model="name"
          :rules="nameRules"
          :counter="250"
          label="Nome da Loja"
          placeholder="Máximo de 250 caracteres"
          required
        >
        </v-text-field>
      </v-col>
      <v-col
        xs="12"
        md="4"
      >
        <v-text-field
          v-model="abbr"
          :rules="abbrRules"
          :counter="15"
          label="Sigla da Loja"
          placeholder="Máximo de 15 caracteres"
          required
        >
        </v-text-field>
      </v-col>
      <v-col
        xs="12"
        md="4"
        >
        <v-select
          v-model="sale_platform"
          :items="$store.state.sale_platforms.map(s => {
            return {text: s.name, value: s.id}
          })"
          label="Plataforma de Pedidos"
          required            
        ></v-select>
      </v-col>
      <v-col
        xs="12"
        md="4"
        >
        <v-select
          v-model="contact_statuses"
          :items="$store.state.contact_statuses.map(s => {
            return {text: s.status, value: s.id}
          })"
          :rules="contactStatusesRules"
          label="Entrar em contato com clientes de:"
          placeholder="Status de pedidos para entrar em contato"
          required
          multiple    
        ></v-select>
      </v-col>
      <v-col
        xs="4"
      >
        <v-text-field
          v-model="url"
          :rules="urlRules"            
          label="Url da loja"
          placeholder="Endereço web da página de vendas, ex: www.meuproduto.com.br"
          required
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-btn
      :disabled="!valid"
      color="success"
      type="submit"
    >
      {{ this.selectedStore ? 'Atualizar' : 'Cadastrar'}}
    </v-btn>      
  </v-form>
</template>

<script>
export default {
  props: {
    selectedStore: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  name: 'Form',
  created() {
    this.$store.dispatch('fetchSalePlatforms');
    this.$store.dispatch('fetchContactStatuses');
  },
  watch: {
    name() {      
      this.abbr = this.name.split(' ').filter((p, index) => index === 0 || p.length > 2).map(p => p[0]).join('.').toUpperCase();      
    },
    contact_statuses(newVal) {
      console.log(newVal)
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        const data = {
          name: this.name,
          abbr: this.abbr,
          url: this.url,
          contact_statuses: this.contact_statuses,
          superboleto: this.superboleto,
          sale_platform_id: this.sale_platform,          
        };
        if (this.selectedStore) {
          data.id = this.selectedStore.id;
          this.$emit('close');
        }
        this.$store.dispatch('createStore', {data});
        this.$emit('close');
      }
    },
  },  
  data () {    
    return {
      valid: false,
      superboleto: this.selectedStore ? this.selectedStore.superboleto : false,
      name: this.selectedStore ? this.selectedStore.name : '',
      abbr: this.selectedStore ? this.selectedStore.abbr : '',
      url: this.selectedStore ? this.selectedStore.url : '',
      sale_platform: this.selectedStore ? this.selectedStore.sale_platform_id : null,
      drop_checkout_delays: this.selectedStore ? this.selectedStore.drop_checkout_delay_id : null,
      contact_statuses: this.selectedStore ? this.selectedStore && this.selectedStore.contact_statuses.map(s=>s.id) : null,
      nameRules: [
        v => !!v || 'Insira o nome da loja',
        v => v && v.length <= 250 || 'O nome da loja deve conter até 250 caracteres',
      ],
      abbrRules: [
        v => !!v || 'Insira uma sigla para a loja',
        v => v && v.length <= 15 || 'A sigla da loja deve conter até 15 caracteres',
      ],
      urlRules: [
        v => !!v || 'Insira a url da página de vendas',
        v => v && v.length <= 512 || 'A sigla da loja deve conter até 512 caracteres',
      ],
      contactStatusesRules: [
        v => !!v || 'Insira pelo menos um status',
        v => v && v.length > 0 || 'Insira pelo menos um status',
      ]
    }
  }
}
</script>

<style lang="css" scoped>
img {
  max-width: 200px;
  height: auto;
}
</style>